<template>
    <div class="uk-width-large uk-container uk-container-center uk-tile">
        <p class="uk-text-center">招待したいユーザーのメールアドレスを入力してください。</p>
        <form class="padding-medium uk-border-rounded border-muted uk-background-default uk-box-shadow-small" @submit.prevent="invite">
            <div v-if="inviteErrors" class="uk-form-danger">
                <ul v-if="inviteErrors.email">
                    <li v-for="msg in inviteErrors.email" :key="msg">{{ msg }}</li>
                </ul>
            </div>
            <div class="uk-margin">
                <label for="invite-email" class="uk-form-label">Email</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: mail"></span>
                    <input type="text" class="uk-input" id="invite-email" v-model="inviteForm.email">
                </div>
            </div>
            <div class="">
                <button type="submit" class="uk-width-1-1 uk-button uk-button-primary">{{ button.invite }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import { getCookieValue } from '../util'
export default {
    data () {
        return {
            tab: 1,
            inviteForm: {
                email: '',
                password: ''
            },
            button: {
                invite: '',
                register: ''
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth.user
        },
        inviteErrors () {
            return this.$store.state.invite.inviteErrorsMessages
        },
        token () {
            return this.$store.state.auth.token
        },
        tempRegisterStatus () {
            return this.$store.state.invite.tempInviteStatus
        },
    },
    methods: {
        async invite () {
            this.button.invite = '...'
            const create_data = this.inviteForm
            create_data['api_token'] = getCookieValue('token')
            create_data['user_group_id'] = this.userInfo.user_group_id

            await this.$store.dispatch('invite/create', create_data)

            if (this.tempRegisterStatus) {
                // 仮登録完了ページに移動
                this.$router.push('/invite/complete')
            }

            this.setButtonText()
        },
        clearError () {
            this.$store.commit('auth/setLoginErrorMessages', null)
        },
        setButtonText() {
            this.button.invite = 'INVITE'
        }
    },
    mounted() {
    },
    created () {
        this.clearError()
        this.setButtonText()
    }
}
</script>
